import { defineMessages } from 'react-intl';

/** The copy of the Upload to Spotify sheet (design artist-profile c2.0–c2.9). */
export const spotifyUploadMessages = defineMessages({
  title: { id: 'app.sml.promote.profile.spotify.title', defaultMessage: 'Upload to Spotify' },
  connected: {
    id: 'app.sml.promote.profile.spotify.connected',
    defaultMessage: '{artist} · Spotify for Artists connected',
  },
  headerVersion: { id: 'app.sml.promote.profile.spotify.headerVersion', defaultMessage: 'Header · version {version}' },
  avatarVersion: {
    id: 'app.sml.promote.profile.spotify.avatarVersion',
    defaultMessage: 'Artist photo · version {version}',
  },
  rightsTick: {
    id: 'app.sml.promote.profile.spotify.rightsTick',
    defaultMessage: 'I have all the legal rights to these images',
  },
  rightsOnce: { id: 'app.sml.promote.profile.spotify.rightsOnce', defaultMessage: 'We ask once per artist.' },
  send: { id: 'app.sml.promote.profile.spotify.send', defaultMessage: 'Send to Spotify' },
  sendBusy: { id: 'app.sml.promote.profile.spotify.sendBusy', defaultMessage: 'Sending…' },
  cancel: { id: 'app.sml.promote.profile.spotify.cancel', defaultMessage: 'Cancel' },
  close: { id: 'app.sml.promote.profile.spotify.close', defaultMessage: 'Close' },
  replaces: {
    id: 'app.sml.promote.profile.spotify.replaces',
    defaultMessage: 'It replaces the header and the photo on your Spotify page now.',
  },
  sendingTitle: { id: 'app.sml.promote.profile.spotify.sending.title', defaultMessage: 'Sending to Spotify' },
  sendingBody: {
    id: 'app.sml.promote.profile.spotify.sending.body',
    defaultMessage: 'About 10 seconds. You can leave this page.',
  },
  doneTitle: { id: 'app.sml.promote.profile.spotify.done.title', defaultMessage: 'On Spotify' },
  doneSince: { id: 'app.sml.promote.profile.spotify.done.since', defaultMessage: 'Live on Spotify since {date}.' },
  notConnectedTitle: {
    id: 'app.sml.promote.profile.spotify.notConnected.title',
    defaultMessage: 'Connect Spotify for Artists',
  },
  notConnectedBody: {
    id: 'app.sml.promote.profile.spotify.notConnected.body',
    defaultMessage:
      'Sign in once with the Spotify for Artists account of {artist}. We use it only to send your images and Canvas.',
  },
  connect: { id: 'app.sml.promote.profile.spotify.connect', defaultMessage: 'Connect' },
  reconnectTitle: {
    id: 'app.sml.promote.profile.spotify.reconnect.title',
    defaultMessage: 'Your Spotify sign-in ended',
  },
  reconnectBody: {
    id: 'app.sml.promote.profile.spotify.reconnect.body',
    defaultMessage: 'Spotify asked for a new sign-in. Nothing was changed on Spotify.',
  },
  signInAgain: { id: 'app.sml.promote.profile.spotify.signInAgain', defaultMessage: 'Sign in again' },
  refusedTitle: { id: 'app.sml.promote.profile.spotify.refused.title', defaultMessage: 'Spotify refused the image' },
  refusedBody: {
    id: 'app.sml.promote.profile.spotify.refused.body',
    defaultMessage: 'Spotify said: "{detail}" Make a full-size file and try again.',
  },
  refusedNoDetail: {
    id: 'app.sml.promote.profile.spotify.refused.noDetail',
    defaultMessage: 'Spotify did not take the image. Make a full-size file and try again.',
  },
  tryAgain: { id: 'app.sml.promote.profile.spotify.tryAgain', defaultMessage: 'Try again' },
  noPermissionTitle: {
    id: 'app.sml.promote.profile.spotify.noPermission.title',
    defaultMessage: 'You cannot edit this profile',
  },
  noPermissionBody: {
    id: 'app.sml.promote.profile.spotify.noPermission.body',
    defaultMessage:
      'Your Spotify for Artists role cannot change the profile of {artist}. Ask an admin of the team for the Editor role.',
  },
  freeTitle: { id: 'app.sml.promote.profile.spotify.free.title', defaultMessage: 'Upgrade to send to Spotify' },
  freeBody: {
    id: 'app.sml.promote.profile.spotify.free.body',
    defaultMessage:
      'Spotify asks for 2660 x 1140 with no logos. Free makes a half-size preview with the MUSIC24 mark. Upgrade to make the full file and send it.',
  },
  manualTitle: { id: 'app.sml.promote.profile.spotify.manual.title', defaultMessage: 'Put it up yourself' },
  manual1: { id: 'app.sml.promote.profile.spotify.manual.1', defaultMessage: 'Download the file.' },
  manual2: {
    id: 'app.sml.promote.profile.spotify.manual.2',
    defaultMessage: 'Spotify for Artists → Profile → Header image (or Artist picture) → Upload.',
  },
  manual3: { id: 'app.sml.promote.profile.spotify.manual.3', defaultMessage: 'Check the preview, then Save.' },
  changedTitle: { id: 'app.sml.promote.profile.spotify.changed.title', defaultMessage: 'Spotify shows another image' },
  changedBody: {
    id: 'app.sml.promote.profile.spotify.changed.body',
    defaultMessage: 'Someone changed it in Spotify for Artists after our upload. Send puts ours back.',
  },
  errorBody: {
    id: 'app.sml.promote.profile.spotify.error.body',
    defaultMessage: 'We could not send the image. Nothing was changed on Spotify. Try again.',
  },
  fileGoneBody: {
    id: 'app.sml.promote.profile.spotify.fileGone.body',
    defaultMessage: 'The file of this version is gone. Make it again, then send it.',
  },
  nothing: {
    id: 'app.sml.promote.profile.spotify.nothing',
    defaultMessage: 'Make the header or the artist photo first. Then send it to Spotify.',
  },
  pickOne: { id: 'app.sml.promote.profile.spotify.pickOne', defaultMessage: 'Pick the header, the photo or both.' },
  rightsRequired: {
    id: 'app.sml.promote.profile.spotify.rightsRequired',
    defaultMessage: 'Tick the line about the legal rights first.',
  },
  filePreview: {
    id: 'app.sml.promote.profile.spotify.file.preview',
    defaultMessage: 'This file is a Free preview. Upgrade to make the full file with no mark.',
  },
  fileTooSmall: {
    id: 'app.sml.promote.profile.spotify.file.tooSmall',
    defaultMessage: 'This file is smaller than Spotify asks. Make it again at full size.',
  },
  fileNotReady: {
    id: 'app.sml.promote.profile.spotify.file.notReady',
    defaultMessage: 'This file is not ready yet. Wait for it, then send it.',
  },
  fileRefused: {
    id: 'app.sml.promote.profile.spotify.file.refused',
    defaultMessage: 'Spotify cannot take this file. Make it again, then send it.',
  },
  busy: { id: 'app.sml.promote.profile.spotify.busy', defaultMessage: 'This image is on its way to Spotify already.' },
  generic: { id: 'app.sml.promote.profile.spotify.generic', defaultMessage: 'That did not work. Try again.' },
});
